import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  Cell,
  LabelList,
} from "recharts";
import GenericCard from "components/UI/GenericCard/GenericCard";

const RecentMonthsPNL = ({ performanceStats }) => {
  const formatMonth = (monthStr) => {
    const date = new Date(monthStr + "-01");
    return date.toLocaleString("default", { month: "short", year: "numeric" });
  };

  return (
    <GenericCard
      className="table-card [&>.content]:h-full [&>.content]:overflow-hidden"
      title="Last 6 Months P&L"
      disableToggle
    >
      <ResponsiveContainer height={450}>
        <BarChart
          data={performanceStats?.last6MonthsPnl?.map((item) => ({
            ...item,
            month: formatMonth(item.month),
            fill: item.pnl >= 0 ? "#4ade80" : "#f87171",
          }))}
          margin={{ top: 20, bottom: 0, left: 10, right: 10 }}
          barCategoryGap={30}
        >
          <CartesianGrid
            strokeDasharray="3 3"
            stroke="#374151"
            strokeOpacity={1}
          />
          <XAxis
            dataKey="month"
            tick={{ fontSize: 14, fill: "#ffffff" }}
            axisLine={false}
            tickLine={false}
          />
          <YAxis
            tick={{ fontSize: 14, fill: "#ffffff" }}
            axisLine={false}
            tickLine={false}
            width={70}
            tickFormatter={(v) => `$${v}`}
            // domain={["dataMin", "dataMax"]}
          />
          <Tooltip
            content={({ active, payload, label }) => {
              if (active && payload && payload.length) {
                const { pnl, trades } = payload[0].payload;
                return (
                  <div
                    style={{
                      background: "rgba(255,255,255,0.95)",
                      border: "1px solid #e5e7eb",
                      borderRadius: 8,
                      padding: 12,
                      color: "#111",
                      minWidth: 120,
                    }}
                  >
                    <div style={{ fontWeight: 600, marginBottom: 4 }}>
                      {label}
                    </div>
                    <div>
                      <span
                        style={{
                          color: pnl >= 0 ? "#22c55e" : "#ef4444",
                          fontWeight: 500,
                        }}
                      >
                        P&L: ${pnl.toFixed(2)}
                      </span>
                    </div>
                    <div>
                      <span style={{ color: "#374151" }}>Trades: {trades}</span>
                    </div>
                  </div>
                );
              }
              return null;
            }}
          />
          <Bar
            dataKey="pnl"
            radius={[8, 8, 0, 0]}
            isAnimationActive={true}
            label={{
              position: "top",
              offset: -20,
              formatter: (value) => (value !== 0 ? `$${value.toFixed(0)}` : ""),
              fill: "#111827",
              fillOpacity: 0.85,
              fontSize: 13,
            }}
          >
            <LabelList
              dataKey="trades"
              position="bottom"
              formatter={(value) => (value > 0 ? `${value} trades` : "")}
              fontSize={12}
            />
            {performanceStats?.last6MonthsPnl?.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={entry.pnl >= 0 ? "#4ade80" : "#f87171"}
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </GenericCard>
  );
};

export default RecentMonthsPNL;
